import React, { useState } from 'react'

import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { login } from '../../Accounts/API'
import { loadUserInfo as loadUserInfoConnect } from '../../../actions/account'
import { setDialog as setDialogConnect } from '../../../actions/navigation'
import Modal from '../Modal'

const SignIn = ({ loadUserInfo, setDialog }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const [errorMessage, setErrorMessage] = useState('')

    const handleSubmit = async e => {
        e.preventDefault()

        try {
            await login(email.toLowerCase(), password)
        } catch (error) {
            if (error.response?.status === 401) {
                return setErrorMessage('Invalid username or password')
            } else {
                throw error
            }
        }
        await loadUserInfo()
        setDialog('')
    }

    return (
        <Modal>
            <div className="form-modal login">
                <header>
                    <h2>Sign In</h2>
                </header>
                <form method="post" onSubmit={handleSubmit}>
                    {errorMessage && <p className="error">{errorMessage}</p>}
                    <label>
                        Email
                        <input
                            autoFocus
                            type="text"
                            name="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </label>
                    <label>
                        Password
                        <input
                            type="password"
                            name="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                    </label>
                    <p className="forgotten-password">
                        <a onClick={() => setDialog('sendPasswordResetLink')}>Forgot your password?</a>
                    </p>
                    <button type="submit" className="button is-primary" disabled={!email || !password}>
                        Sign In
                    </button>
                </form>
                <p className="sign-up">
                    Don&#39;t have an account yet?{' '}
                    <button type="button" onClick={() => setDialog('createAccount')}>
                        Sign up.
                    </button>
                </p>
            </div>
        </Modal>
    )
}

SignIn.propTypes = {
    // redux actions
    loadUserInfo: PropTypes.func.isRequired,
    setDialog: PropTypes.func.isRequired
}

export default connect(null, dispatch => ({
    loadUserInfo: () => dispatch(loadUserInfoConnect()),
    setDialog: dialogName => dispatch(setDialogConnect(dialogName))
}))(SignIn)
